import styled from "styled-components";

/**
 * DatePicker — popover de selecao de data inspirado no mockup (Todoist-like):
 * presets a esquerda + calendario a direita + toggle "Ignorar dias nao uteis".
 * Usa tokens canonicos (funciona em light e dark).
 */

export const Pop = styled.div`
  position: fixed;
  /* Acima do Overlay do SlideOverPanel (z-index 1000) — senão o calendário
     fica atrás do scrim e some no painel "Nova tarefa" de Minhas Pendências. */
  z-index: 1100;
  width: min(92vw, 520px);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl, 12px);
  box-shadow: var(--shadow-3, 0 16px 40px rgba(0, 0, 0, 0.28));
  overflow: hidden;
`;

export const Cols = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Presets = styled.div`
  border-right: 1px solid var(--divider);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 1px;

  @media (max-width: 560px) {
    border-right: 0;
    border-bottom: 1px solid var(--divider);
  }
`;

export const PresetRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--ink);
  font: inherit;
  font-size: 13px;
  text-align: left;
  padding: 9px 10px;
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;

  .hint {
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--ink-3);
  }

  &:hover {
    background: var(--surface-hover);
  }

  &.limpar {
    margin-top: 4px;
    border-top: 1px solid var(--divider);
    border-radius: 0;
    color: var(--ink-3);
  }
`;

export const Cal = styled.div`
  padding: 12px 14px 14px;
`;

export const CalHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  strong {
    font-family: var(--font-display);
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
  }
`;

export const CalNav = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  button {
    border: 0;
    background: transparent;
    color: var(--ink-3);
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: var(--radius-sm, 6px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  button:hover {
    background: var(--surface-hover);
    color: var(--ink);
  }
  button svg {
    width: 14px;
    height: 14px;
  }
`;

export const WeekRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;

  span {
    text-align: center;
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--ink-3);
    padding: 4px 0;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const Day = styled.button`
  aspect-ratio: 1 / 1;
  border: 0;
  background: ${({ $sel }) => ($sel ? "var(--accent)" : "transparent")};
  color: ${({ $sel, $out, $weekend }) =>
    $sel ? "#fff" : $out ? "var(--ink-4)" : $weekend ? "var(--ink-3)" : "var(--ink)"};
  font: inherit;
  font-size: 13px;
  border-radius: 999px;
  cursor: pointer;
  display: grid;
  place-items: center;
  position: relative;

  ${({ $hoje }) =>
    $hoje &&
    `box-shadow: inset 0 0 0 1.5px var(--accent); color: var(--accent);`}

  &:hover {
    background: ${({ $sel }) => ($sel ? "var(--accent)" : "var(--surface-hover)")};
  }
`;

export const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-top: 1px solid var(--divider);
  font-size: 13px;
  color: var(--ink-2);
`;

export const Toggle = styled.button`
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: 999px;
  border: 0;
  cursor: pointer;
  background: ${({ $on }) => ($on ? "var(--accent)" : "var(--surface-3)")};
  transition: background 0.15s ease;
  flex-shrink: 0;

  .knob {
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? "18px" : "2px")};
    width: 18px;
    height: 18px;
    border-radius: 999px;
    background: #fff;
    transition: left 0.15s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  }
`;
